import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index";

const LandingPage = () =>
    import(
        /* webpackChunkName: "landing-route" */ "./components/main/umum/LandingPage.vue"
    );
const Statistik = () =>
    import(
        /* webpackChunkName: "landing-route" */ "./components/main/umum/Statistik.vue"
    );
const CariGuru = () =>
    import(
        /* webpackChunkName: "landing-route" */ "./components/main/umum/CariGuru.vue"
    );
const CariTendik = () =>
    import(
        /* webpackChunkName: "landing-route" */ "./components/main/umum/CariTendik.vue"
    );
const SekolahDepan = () =>
    import(
        /* webpackChunkName: "landing-route" */ "./components/main/umum/sekolah/SekolahDepan.vue"
    );
const NotFoundUmum = () =>
    import(
        /* webpackChunkName: "landing-route" */ "./components/main/NotFoundUmum.vue"
    );

const JenjangSekolah = () =>
    import(
        /* webpackChunkName: "dev-route" */ "./components/main/master/JenjangSekolah.vue"
    );
const MyEdu = () =>
    import(
        /* webpackChunkName: "dev-route" */ "./components/main/master/MyEdu.vue"
    );
const StatusPegawai = () =>
    import(
        /* webpackChunkName: "dev-route" */ "./components/main/master/StatusPegawai.vue"
    );
const MyBackup = () =>
    import(
        /* webpackChunkName: "dev-route" */ "./components/main/dev/MyBackup.vue"
    );

// const IndexMain = () => import(/* webpackChunkName: "main-route" */ './components/main/IndexMain.vue');
import IndexMain from "./components/main/IndexMain.vue";
const NotFound = () =>
    import(
        /* webpackChunkName: "main-route" */ "./components/main/NotFound.vue"
    );
const ServerError = () =>
    import(
        /* webpackChunkName: "main-route" */ "./components/main/ServerError.vue"
    );
const Login = () =>
    import(/* webpackChunkName: "main-route" */ "./components/auth/Login.vue");
// const Register = () => import(/* webpackChunkName: "main-route" */ './components/auth/Register.vue');
const Dashboard = () =>
    import(
        /* webpackChunkName: "main-route" */ "./components/main/Dashboard.vue"
    );
const AkunSaya = () =>
    import(
        /* webpackChunkName: "main-route" */ "./components/main/AkunSaya.vue"
    );
const MyPesan = () =>
    import(
        /* webpackChunkName: "main-route" */ "./components/main/MyPesan.vue"
    );

const PetaSekolah = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/PetaSekolah.vue"
    );
const InfoSingkat = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/InfoSingkat.vue"
    );
const DataSekolah = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/DataSekolah.vue"
    );
const SemuaMugu = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaMugu.vue"
    );
const SemuaMuten = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaMuten.vue"
    );
const DataAkun = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/DataAkun.vue"
    );
const SemuaGuru = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaGuru.vue"
    );
const SemuaTendik = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaTendik.vue"
    );
const SemuaKepsek = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaKepsek.vue"
    );
const SemuaGukel = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaGukel.vue"
    );
const SemuaTenkel = () =>
    import(
        /* webpackChunkName: "disdik-route" */ "./components/main/disdik/SemuaTenkel.vue"
    );

const DataJenisGuru = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/JenisGuru.vue"
    );
const JenisTendik = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/JenisTendik.vue"
    );
const MataPelajaran = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/MataPelajaran.vue"
    );
const KecamKelur = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/KecamKelur.vue"
    );
const PangkatOne = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/PangkatOne.vue"
    );
const PangkatTwo = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/PangkatTwo.vue"
    );
const RombelTingkat = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/RombelTingkat.vue"
    );
const TahunAjaran = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/TahunAjaran.vue"
    );
const TugasTambahan = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/TugasTambahan.vue"
    );
const AlasanKeluar = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/AlasanKeluar.vue"
    );
const Dinas = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/Dinas.vue"
    );
const Agama = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/Agama.vue"
    );
const DaftarBerkas = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/DaftarBerkas.vue"
    );
const Kontak = () =>
    import(
        /* webpackChunkName: "master-route" */ "./components/main/master/Kontak.vue"
    );

const GuruApprove = () =>
    import(
        /* webpackChunkName: "guru-route" */ "./components/main/guru/GuruApprove.vue"
    );
const GuruQueue = () =>
    import(
        /* webpackChunkName: "guru-route" */ "./components/main/guru/GuruQueue.vue"
    );
const GuruLengkap = () =>
    import(
        /* webpackChunkName: "guru-route" */ "./components/main/guru/GuruLengkap.vue"
    );
const DaguNoduk = () =>
    import(
        /* webpackChunkName: "guru-route" */ "./components/main/guru/DaguNoduk.vue"
    );

const TendikQueue = () =>
    import(
        /* webpackChunkName: "tendik-route" */ "./components/main/tendik/TendikQueue.vue"
    );
const TendikApprove = () =>
    import(
        /* webpackChunkName: "tendik-route" */ "./components/main/tendik/TendikApprove.vue"
    );
const TendikLengkap = () =>
    import(
        /* webpackChunkName: "tendik-route" */ "./components/main/tendik/TendikLengkap.vue"
    );

const ProfileSekolah = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/ProfileSekolah.vue"
    );
const SekolahLengkap = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/SekolahLengkap.vue"
    );
const RombelSekolah = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/RombelSekolah.vue"
    );
const CariKebutuhanGuru = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/CariKebutuhanGuru.vue"
    );
const VisiMisi = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/VisiMisi.vue"
    );
const TitikKoordinat = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/TitikKoordinat.vue"
    );
const StrukturOrganisasi = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/StrukturOrganisasi.vue"
    );
const DataMugu = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/DataMugu.vue"
    );
const DataMuten = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/DataMuten.vue"
    );
const DataGukel = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/DataGukel.vue"
    );
const DataTenkel = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/DataTenkel.vue"
    );
const KontakAduan = () =>
    import(
        /* webpackChunkName: "sekolah-route" */ "./components/main/sekolah/KontakAduan.vue"
    );

const KalenderPendidikan = () =>
    import(
        /* webpackChunkName: "kalender-route" */ "./components/main/KalenderPendidikan.vue"
    );

const LaporanDataSekolah = () =>
    import(
        /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanDataSekolah.vue"
    );
const LaporanGuruSertifikasi = () =>
    import(
        /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanGuruSertifikasi.vue"
    );
const LaporanDataKekuranganGuru = () =>
    import(
        /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanDataKekuranganGuru.vue"
    );
const LaporanCalonGuruPensiun = () =>
    import(
        /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanCalonGuruPensiun.vue"
    );

const Config = () =>
    import(
        /* webpackChunkName: "super-route" */ "./components/main/super/Config.vue"
    );
const ConfigPenginputan = () =>
    import(
        /* webpackChunkName: "super-route" */ "./components/main/super/ConfigPenginputan.vue"
    );

const ExportExcel = () =>
    import(
        /* webpackChunkName: "super-route" */ "./components/main/export/excel/ExportExcel.vue"
    );

const AppInfo = () =>
    import(
        /* webpackChunkName: "log-route" */ "./components/main/dev/AppInfo.vue"
    );

Vue.use(VueRouter);

const routes = [
    {
        path: "/server-error",
        name: "ServerError",
        component: ServerError,
        meta: { guest: true }
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { guest: true }
    },
    // {
    //   path: "/register",
    //   name: "Register",
    //   component: Register,
    //   meta: { guest: true },
    // },
    {
        path: "/",
        name: "LandingPage",
        component: LandingPage,
        meta: { umum: true }
    },
    {
        path: "/statistik",
        name: "Statistik",
        component: Statistik,
        meta: { umum: true }
    },
    {
        path: "/cari-guru",
        name: "CariGuru",
        component: CariGuru,
        meta: { umum: true }
    },
    {
        path: "/cari-tendik",
        name: "CariTendik",
        component: CariTendik,
        meta: { umum: true }
    },
    {
        path: "/data-sekolah/:id",
        name: "SekolahDepan",
        component: SekolahDepan,
        meta: { umum: true }
    },
    {
        path: "/app",
        component: IndexMain,
        meta: { requiresAuth: true },
        children: [
            {
                path: "/app",
                redirect: "/app/dashboard"
            },
            {
                path: "/app/server-error",
                name: "AppServerError",
                components: {
                    default: IndexMain,
                    MainView: ServerError
                }
            },
            {
                path: "/app/config",
                name: "Config",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: Config
                }
            },
            {
                path: "/app/export-excel",
                name: "ExportExcel",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: ExportExcel
                }
            },
            {
                path: "/app/config-penginputan",
                name: "ConfigPenginputan",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: ConfigPenginputan
                }
            },
            {
                path: "/app/app-info",
                name: "AppInfo",
                components: {
                    default: IndexMain,
                    MainView: AppInfo
                }
            },
            {
                path: "/app/dashboard",
                name: "Dashboard",
                // meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: Dashboard
                }
            },
            {
                path: "/app/data-input-terakhir",
                name: "DataInputTerakhir",
                components: {
                    default: IndexMain,
                    MainView: () =>
                        import(
                            /* webpackChunkName: "data-input-terakhir" */ "./components/main/data-input-terakhir/pages/index.vue"
                        )
                }
            },
            {
                path: "/app/jenjang-sekolah",
                name: "JenjangSekolah",
                meta: { role: "dev" },
                components: {
                    default: IndexMain,
                    MainView: JenjangSekolah
                }
            },
            {
                path: "/app/semua-guru-keluar",
                name: "SemuaGukel",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaGukel
                }
            },
            {
                path: "/app/semua-tendik-keluar",
                name: "SemuaTenkel",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaTenkel
                }
            },
            {
                path: "/app/semua-mutasi-guru",
                name: "SemuaMugu",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaMugu
                }
            },
            {
                path: "/app/semua-mutasi-tendik",
                name: "SemuaMuten",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaMuten
                }
            },
            {
                path: "/app/semua-guru",
                name: "SemuaGuru",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaGuru
                }
            },
            {
                path: "/app/semua-tendik",
                name: "SemuaTendik",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaTendik
                }
            },
            {
                path: "/app/semua-kepsek",
                name: "SemuaKepsek",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SemuaKepsek
                }
            },
            {
                path: "/app/info-singkat",
                name: "InfoSingkat",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: InfoSingkat
                }
            },
            {
                path: "/app/kalender-pendidikan",
                name: "KalenderPendidikan",
                components: {
                    default: IndexMain,
                    MainView: KalenderPendidikan
                }
            },
            {
                path: "/app/akun-saya",
                name: "AkunSaya",
                components: {
                    default: IndexMain,
                    MainView: AkunSaya
                }
            },
            {
                path: "/app/semua-sekolah",
                name: "DataSekolah",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: DataSekolah
                }
            },
            {
                path: "/app/data-sekolah/:id",
                name: "SekolahLengkap",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: SekolahLengkap
                }
            },
            {
                path: "/app/profile-umum",
                name: "ProfileSekolah",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: ProfileSekolah
                }
            },
            {
                path: "/app/titik-koordinat",
                name: "TitikKoordinat",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: TitikKoordinat
                }
            },
            {
                path: "/app/visi-misi",
                name: "VisiMisi",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: VisiMisi
                }
            },
            {
                path: "/app/struktur-organisasi",
                name: "StrukturOrganisasi",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: StrukturOrganisasi
                }
            },
            {
                path: "/app/data-bidang-guru",
                name: "DataJenisGuru",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: DataJenisGuru
                }
            },
            {
                path: "/app/data-jenis-tendik",
                name: "JenisTendik",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: JenisTendik
                }
            },
            {
                path: "/app/mata-pelajaran",
                name: "MataPelajaran",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: MataPelajaran
                }
            },
            {
                path: "/app/data-kec-kel",
                name: "KecamKelur",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: KecamKelur
                }
            },
            {
                path: "/app/dinas",
                name: "Dinas",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: Dinas
                }
            },
            {
                path: "/app/agama",
                name: "Agama",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: Agama
                }
            },
            {
                path: "/app/kontak",
                name: "Kontak",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: Kontak
                }
            },
            {
                path: "/app/status-pegawai",
                name: "StatusPegawai",
                meta: { role: "dev" },
                components: {
                    default: IndexMain,
                    MainView: StatusPegawai
                }
            },
            {
                path: "/app/backup",
                name: "MyBackup",
                meta: { role: "superadmin" },
                components: {
                    default: IndexMain,
                    MainView: MyBackup
                }
            },
            {
                path: "/app/daftar-berkas",
                name: "DaftarBerkas",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: DaftarBerkas
                }
            },
            {
                path: "/app/rombel-tingkat",
                name: "RombelTingkat",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: RombelTingkat
                }
            },
            {
                path: "/app/pangkat-guru",
                name: "PangkatOne",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: PangkatOne
                }
            },
            {
                path: "/app/pangkat-tendik",
                name: "PangkatTwo",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: PangkatTwo
                }
            },
            {
                path: "/app/daftar-pendidikan",
                name: "MyEdu",
                meta: { role: "dev" },
                components: {
                    default: IndexMain,
                    MainView: MyEdu
                }
            },
            {
                path: "/app/tahun-ajaran",
                name: "TahunAjaran",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: TahunAjaran
                }
            },
            {
                path: "/app/tugas-tambahan",
                name: "TugasTambahan",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: TugasTambahan
                }
            },
            {
                path: "/app/alasan-keluar",
                name: "AlasanKeluar",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: AlasanKeluar
                }
            },
            {
                path: "/app/rombel-sekolah",
                name: "RombelSekolah",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: RombelSekolah
                }
            },
            {
                path: "/app/cari-kebutuhan-guru",
                name: "CariKebutuhanGuru",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: CariKebutuhanGuru
                }
            },
            {
                path: "/app/guru-disetujui",
                name: "GuruApprove",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: GuruApprove
                }
            },
            {
                path: "/app/pengajuan-guru",
                name: "GuruQueue",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: GuruQueue
                }
            },
            {
                path: "/app/guru-non-induk",
                name: "DaguNoduk",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: DaguNoduk
                }
            },
            {
                path: "/app/data-guru/:id",
                name: "GuruLengkap",
                components: {
                    default: IndexMain,
                    MainView: GuruLengkap
                }
            },
            {
                path: "/app/mutasi-guru",
                name: "DataMugu",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: DataMugu
                }
            },
            {
                path: "/app/mutasi-tendik",
                name: "DataMuten",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: DataMuten
                }
            },
            {
                path: "/app/guru-keluar",
                name: "DataGukel",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: DataGukel
                }
            },
            {
                path: "/app/tendik-keluar",
                name: "DataTenkel",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: DataTenkel
                }
            },
            {
                path: "/app/kontak-aduan",
                name: "KontakAduan",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: KontakAduan
                }
            },
            {
                path: "/app/tendik-disetujui",
                name: "TendikApprove",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: TendikApprove
                }
            },
            {
                path: "/app/pengajuan-tendik",
                name: "TendikQueue",
                meta: { role: "ops" },
                components: {
                    default: IndexMain,
                    MainView: TendikQueue
                }
            },
            {
                path: "/app/data-tendik/:id",
                name: "TendikLengkap",
                components: {
                    default: IndexMain,
                    MainView: TendikLengkap
                }
            },
            {
                path: "/app/data-akun",
                name: "DataAkun",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: DataAkun
                }
            },
            {
                path: "/app/peta-sekolah",
                name: "PetaSekolah",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: PetaSekolah
                }
            },
            {
                path: "/app/my-pesan",
                name: "MyPesan",
                components: {
                    default: IndexMain,
                    MainView: MyPesan
                }
            },
            {
                path: "/app/laporan-data-guru",
                name: "LaporanDataGuru",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: () =>
                        import(
                            /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanDataGuru.vue"
                        )
                }
            },
            {
                path: "/app/laporan-data-tendik",
                name: "LaporanDataTendik",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: () =>
                        import(
                            /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanDataTendik.vue"
                        )
                }
            },
            {
                path: "/app/laporan-data-kepala-sekolah",
                name: "LaporanDataKepalaSekolah",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: () =>
                        import(
                            /* webpackChunkName: "laporan-route" */ "./components/main/laporan/LaporanDataKepalaSekolah.vue"
                        )
                }
            },
            {
                path: "/app/laporan-data-sekolah",
                name: "LaporanDataSekolah",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: LaporanDataSekolah
                }
            },
            {
                path: "/app/laporan-sertifikasi-guru",
                name: "LaporanGuruSertifikasi",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: LaporanGuruSertifikasi
                }
            },
            {
                path: "/app/laporan-data-kekurangan-guru",
                name: "LaporanDataKekuranganGuru",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: LaporanDataKekuranganGuru
                }
            },
            {
                path: "/app/laporan-calon-guru-pensiun",
                name: "LaporanCalonGuruPensiun",
                meta: { role: "admin" },
                components: {
                    default: IndexMain,
                    MainView: LaporanCalonGuruPensiun
                }
            },
            {
                path: "/app/404",
                name: "NotFound",
                components: {
                    default: IndexMain,
                    MainView: NotFound
                }
            },
            {
                path: "/app/*",
                redirect: "/app/404"
            }
        ]
    },
    {
        path: "/404",
        name: "NotFoundUmum",
        component: NotFoundUmum
    },
    {
        path: "/*",
        redirect: "/404"
    }
];

const router = new VueRouter({
    mode: "history",
    routes
    // scrollBehavior(to, from, savedPosition) {
    //   if (to.hash) {
    //     console.log(to.hash)
    //     return new Promise((resolve, reject) => {
    //       setTimeout(() => {
    //         resolve({
    //           selector: to.hash
    //         });
    //       }, 1000);
    //     });
    //   }
    // }
});

function loggedIn() {
    const token = localStorage.getItem("token");
    return token;
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!loggedIn()) {
            next({
                path: "/login",
                query: { redirect: to.fullPath }
            });
        } else if (loggedIn() && to.meta.role == "admin") {
            if (
                store.getters["auth/getUserRole"] == "admin" ||
                store.getters["auth/getUserRole"] == "superadmin" ||
                store.getters["auth/getUserRole"] == "dev"
            ) {
                next();
            } else {
                async function _getRole() {
                    try {
                        var hasPermission = await store.dispatch(
                            "auth/getUser"
                        );

                        if (hasPermission.oke) {
                            if (
                                store.getters["auth/getUserRole"] == "admin" ||
                                store.getters["auth/getUserRole"] ==
                                    "superadmin" ||
                                store.getters["auth/getUserRole"] == "dev"
                            ) {
                                next();
                            } else {
                                next({
                                    name: "NotFound"
                                });
                            }
                        }
                    } catch (e) {
                        console.log(e);
                        next({
                            name: "NotFound" // back to safety route //
                        });
                    }
                }
                _getRole();
            }
        } else if (loggedIn() && to.meta.role == "ops") {
            if (store.getters["auth/getUserRole"] == "ops") {
                next();
            } else {
                async function _getRole() {
                    try {
                        var hasPermission = await store.dispatch(
                            "auth/getUser"
                        );

                        if (hasPermission.oke) {
                            if (store.getters["auth/getUserRole"] == "ops") {
                                next();
                            } else {
                                next({
                                    name: "NotFound"
                                });
                            }
                        }
                    } catch (e) {
                        console.log(e);
                        next({
                            name: "NotFound" // back to safety route //
                        });
                    }
                }
                _getRole();
            }
        } else if (loggedIn() && to.meta.role == "dev") {
            if (store.getters["auth/getUserRole"] == "dev") {
                next();
            } else {
                async function _getRole() {
                    try {
                        var hasPermission = await store.dispatch(
                            "auth/getUser"
                        );
                        if (hasPermission.oke) {
                            if (store.getters["auth/getUserRole"] == "dev") {
                                next();
                            } else {
                                next({
                                    name: "NotFound"
                                });
                            }
                        }
                    } catch (e) {
                        console.log(e);
                        next({
                            name: "NotFound" // back to safety route //
                        });
                    }
                }
                _getRole();
            }
        } else {
            next();
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (loggedIn()) {
            next({
                path: "/app/dashboard",
                query: { redirect: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        next(); // make sure to always call next()!
    }
});

export default router;
